<app-customer-slots [slots]="customer.aboutUs"></app-customer-slots>
